import queryString from 'query-string'
import _ from 'lodash'

const arrayAttr = ['welding_process_ids', 'product_type_ids', 'type_of_weld_ids', 'filler_material_group_ids',
  'filler_material_ids', 'welding_position_ids', 'weld_detail_ids', 'revalidation_metgod_ids', 'type_of_current_polarity_ids']

export function prepareFiltersFromUrl(search, forQuery = false) {
  let filtersFromUrl = _.omit(queryString.parse(search), 'page', 'size', 'merge_by_cert_no', '')
  filtersFromUrl.standard_id && (filtersFromUrl.standard_id = Number(filtersFromUrl.standard_id))
  filtersFromUrl.material_group && (filtersFromUrl.material_group = [filtersFromUrl.material_group].flat())
  arrayAttr.forEach(attr => {
    filtersFromUrl[attr] && (filtersFromUrl[attr] = (Array.isArray(filtersFromUrl[attr]) ?
      filtersFromUrl[attr].map(o => Number(o)) : Number(filtersFromUrl[attr])))
  })

  if (filtersFromUrl.dimensions && forQuery) {
    filtersFromUrl.dimensions = JSON.parse(filtersFromUrl.dimensions)
  } else if (filtersFromUrl.dimensions) {
    filtersFromUrl.dimensions = prepareDimensionsArray(filtersFromUrl.dimensions)
  }

  [undefined, 'true'].includes(filtersFromUrl.active) && (filtersFromUrl.active = true)
  filtersFromUrl.active === 'false' && (filtersFromUrl.active = false)
  return filtersFromUrl
}

function prepareDimensionsArray(dimensions) {
  let dimensionsArray = []
  if (dimensions) {
    let parsedDimensions = JSON.parse(dimensions)
    for (const [k, v] of Object.entries(parsedDimensions)) {
      dimensionsArray.push({ dimension_type: k, from: v.from, to: v.to })
    }
  }
  return dimensionsArray
}

export function getDimensionsValueForUrl(dimensions_array) {
  let preparedDimensionsValue = {}
  dimensions_array.map(dimension => {
    if (dimension.dimension_type !== '') {
      preparedDimensionsValue[dimension.dimension_type] = {
        from: dimension.from || 0,
        to: dimension.to || null
      }
    }
    return preparedDimensionsValue
  })
  return JSON.stringify(preparedDimensionsValue)
}



// WEBPACK FOOTER //
// ./src/components/Welders/helpers/filtersHelper.js